import { z } from "zod";

export const exportReportFormSchema = z.object({
  date: z.tuple([z.date(), z.date()]),
  assignedCompanyName: z.string(),
  driverExternalSupplier: z.string(),
  reportType: z.string(),
});
